import React, { useContext, useEffect } from 'react';
import {
  ComponentFactory,
  ComponentParams,
  ComponentRendering,
  Field,
  Placeholder,
  RichText,
  SitecoreContext,
} from '@sitecore-jss/sitecore-jss-react';
import { Link } from 'react-router-dom';
import './index.scss';
import { APIWebstoreContext } from '../../../context/globalContext';
import { IoPrintOutline } from 'react-icons/io5';
import { PAYMENT_TYPES } from '../../../utils/constants';

export type OrderPendingProps = {
  fields: {
    PendingText: Field<string>;
    Title: Field<string>;
  };
  sitecoreContext: SitecoreContext & { pageEditing: boolean };
};

interface Props {
  children: React.ReactElement;
  componentFactory: ComponentFactory;
  rendering: ComponentRendering;
  params: ComponentParams;
}

const OrderPending = (props: OrderPendingProps & Props): React.JSX.Element => {
  const { fields, rendering } = props;
  const { state } = useContext(APIWebstoreContext);

  function replaceText(): Field<string> {
    let orderPendingText = fields.PendingText.value;
    orderPendingText = orderPendingText.replace(
      '##PAYMENT_TYPE##',
      PAYMENT_TYPES[state?.paymentType ?? '']
    );
    orderPendingText = orderPendingText.replace('##EMAIL_ID##', state?.userEmail || '');
    orderPendingText = orderPendingText.replace('##ORDER_NUMBER##', state?.lastOrderId || '');
    fields.PendingText.value = orderPendingText;
    return fields.PendingText;
  }

  useEffect(() => {
    window.history.replaceState(null, 'API WebStore | Order history', '/orders/history');
  }, []);

  return (
    <div className="centerContainer">
      <div className="orderPendingSection">
        <div className="orderPendingHeader">
          <h1>{fields?.Title?.value}</h1>
          <div className="orderSummaryEditCart">
            <IoPrintOutline />

            <Link
              to={
                state?.lastOrderId !== ''
                  ? `/orders/unifiedreceipt?referenceNo=${state?.lastOrderId}`
                  : '/orders/history'
              }
              id="OrderHistory"
              target="_blank"
            >
              View Pro Forma Invoice
            </Link>
          </div>
        </div>
        <div className="orderPendingContent">
          <RichText className="orderPendingRichText" field={replaceText()} />
        </div>
        <Placeholder name="continue_shopping" rendering={rendering} />
      </div>
    </div>
  );
};

export default OrderPending;
